const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export const endpoints = {
  // Authentication
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    register: `${API_BASE_URL}/auth/register`,
    logout: `${API_BASE_URL}/auth/logout`,
    refreshToken: `${API_BASE_URL}/auth/refresh`,
    captcha: `${API_BASE_URL}/auth/captcha`,
    verifyCaptcha: `${API_BASE_URL}/auth/verify-captcha`,
    mfaSetup: `${API_BASE_URL}/auth/mfa/setup`,
    mfaVerify: `${API_BASE_URL}/auth/mfa/verify`,
    requestPasswordReset: `${API_BASE_URL}/auth/password-reset/request`,
    resetPassword: `${API_BASE_URL}/auth/password-reset/confirm`,
  },
  
  // User Profile
  user: {
    profile: `${API_BASE_URL}/user/profile`,
    updateProfile: `${API_BASE_URL}/user/profile/update`,
    uploadAvatar: `${API_BASE_URL}/user/avatar`,
  },
  
  // Programs/Courses
  programs: {
    list: `${API_BASE_URL}/programs`,
    details: (id) => `${API_BASE_URL}/programs/${id}`,
    enroll: (id) => `${API_BASE_URL}/programs/${id}/enroll`,
    enrolled: `${API_BASE_URL}/programs/enrolled`,
    upcoming: `${API_BASE_URL}/programs/upcoming`,
    featured: `${API_BASE_URL}/programs/featured`,
  },
  
  // Attendance
  attendance: {
    list: (programId) => `${API_BASE_URL}/attendance/${programId}`,
    mark: `${API_BASE_URL}/attendance/mark`,
    export: (programId) => `${API_BASE_URL}/attendance/${programId}/export`,
    qrCode: (sessionId) => `${API_BASE_URL}/attendance/qr/${sessionId}`,
  },
  
  // Notifications
  notifications: {
    list: `${API_BASE_URL}/notifications`,
    markRead: (id) => `${API_BASE_URL}/notifications/${id}/read`,
    markAllRead: `${API_BASE_URL}/notifications/read-all`,
    delete: (id) => `${API_BASE_URL}/notifications/${id}`,
  },
  
  // Resources
  resources: {
    upload: `${API_BASE_URL}/resources/upload`,
    download: (id) => `${API_BASE_URL}/resources/${id}/download`,
  },
};

export default endpoints;
